export var PAGE_NAVIGATION_CLASS_PREFIX = 'PageNavigation';
export var pageNavigationRootTestId = 'PageNavigationRoot';
export var pageNavigationPageButtonTestId = 'PageNavigationPageButton';